import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import useDeviceSettings from '@/containers/DevicesPage/components/DeviceSettings/hooks/useDeviceSettingsContent';
import useUamAssets from '@/hooks/uam/useUamAssets';
import {
    selectCurrentProductInfo,
    selectIsDeviceDataLoading,
    selectIsSelectedDeviceConnectedToIot,
} from '@/state/selectors/device';
import {hideLoader, showLoader} from '@/state/slices/loadersSlice';
import {dispatch} from '@/state/store';

const useFetchUamAssets = () => {
    const isSelectedDeviceConnectedToIot = useSelector(selectIsSelectedDeviceConnectedToIot);
    const {codentify, holder} = useSelector(selectCurrentProductInfo) || {};
    const {isAnySettingEnabled} = useDeviceSettings();
    const isDeviceDataLoading = useSelector(selectIsDeviceDataLoading);

    useEffect(() => {
        if (isDeviceDataLoading) {
            dispatch(showLoader());
        } else {
            dispatch(hideLoader());
        }
    }, [isDeviceDataLoading]);

    useUamAssets({
        isDisabled: !isAnySettingEnabled || isSelectedDeviceConnectedToIot,
        codentify,
        holderCodentify: holder?.codentify,
    });
};

export default useFetchUamAssets;
